import request from '@/utils/request'

export function pagePushRecord(query) {
  return request({
    url: '/push/manage/page',
    method: 'get',
    params: query
  })
}

export function listPushSources() {
  return request({
    url: '/push/manage/sources',
    method: 'get'
  })
}

export function sendPush(data) {
  return request({
    url: '/push/manage/send',
    method: 'post',
    data
  })
}
